import { Link } from "react-router-dom";
import { approvedArticles } from "@/content/resources/articles";

const FromVentSection = () => {
  const list = approvedArticles().slice(0, 4);
  return (
    <section className="mx-auto max-w-7xl px-5 py-16 md:px-10">
      <p className="text-lg text-muted-foreground">
        Looking for somewhere to vent anonymously?{" "}
        <Link to="/anonymous-vent-app" className="text-brand underline underline-offset-4 hover:text-foreground">
          Learn how Vent works →
        </Link>
      </p>
      {list.length > 0 && (
        <div className="mt-10">
          <h2 className="font-display uppercase text-xs tracking-[0.3em] text-muted-foreground">From Vent</h2>
          <ul className="mt-4 grid gap-3 sm:grid-cols-2">
            {list.map((a) => (
              <li key={a.slug}>
                <Link to={`/resources/${a.slug}`} className="text-foreground underline-offset-4 hover:text-brand hover:underline">
                  {a.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};

export default FromVentSection;
